export default class NotificationBar {
    static init() {
        const notifications = document.querySelectorAll('.notification-bar');
        if (!notifications.length) {
            return;
        }

        Array.from(notifications).forEach(element => {
            new NotificationBar(element);
        });
    }

    constructor(element) {
        this.element = element;
        this.state = this.getState() || 'visible';

        this.setState(this.state);
    }

    getState() {
		if (!this.element.dataset.hasOwnProperty('dismissible')) {
			return 'visible'
		}

        return localStorage.getItem(this.element.id);
    }

    setState(state) {
        this.state = state;
        localStorage.setItem(this.element.id, state);
        switch (state) {
            case 'hidden':
                this.hide();
                break;
            case 'visible':
                this.show();
                const closeButton = this.element.querySelector('.notification-bar__btn-close');
                if(closeButton) closeButton.addEventListener('click', (event) => {
                    this.setState('hidden');
                });
                break;
        }
    }

    show() {
        this.element.classList.remove('hidden');
    }
    hide() {
        this.element.classList.add('hidden');
        document.body.style.setProperty('--notification-bar-height', '0px');
    }
}
